module.exports = __webpack_public_path__ + "e1d33883af6e2a0abdcddd27400e6e7b.png";